import React, { Component } from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";
import API from "../../actions";
import Joi from "joi-browser";


class EditCompanyForm extends Component {
    state = {
        data: {},
        errors: {},
        alert: {
            open: false,
            message: ''
        }
    };

    schema = {
        address: Joi.string().required().label("Firmaadresse"),
        post: Joi.number().min(0).max(99999999).required().label("Postnummer"),
        town: Joi.string().max(100).required().label("By"),
        freeTextsPerMonth: Joi.number().min(0).max(99999999).required().label("Free SMS"),
    };

    validateProperty = ({ name, value }) => {
        const obj = { [name]: value };
        let schema = { [name]: this.schema[name] };
        const result = Joi.validate(obj, schema);
        if (!result.error) return null;
        return result.error.details[0].message;
    };

    handleChange = ({ currentTarget: input }) => {
        const errors = { ...this.state.errors };
        const errorMessage = this.validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];
        const data = { ...this.state.data };
        data[input.name] = input.value;

        this.setState({ data, errors });
    };

    validateForm = () => {
        const options = {
            abortEarly: false
        };

        const result = Joi.validate(this.state.data, this.schema, options);
        if (!result.error) return null;
        const errors = {};
        for (let item of result.error.details) errors[item.path[0]] = item.message;
        return errors;
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        this.setState({ errors: errors || {} });
        if (errors) {
            return;
        }

        try {
            const company = { ...{ id: this.props.company.id }, ...this.state.data };

            await API.setCompanySuperadmin(company);
            this.props.onSaveSuccess();

        } catch (err) {
            alert(err ? "Fejl: " + err : 'Fejl: Cannot connect to the server. Please try again.');
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.dialogOpen) {
            this.setState({
                data: {
                    address: nextProps.company.address,
                    post: nextProps.company.post,
                    town: nextProps.company.town,
                    freeTextsPerMonth: nextProps.company.freeTextsPerMonth,
                }
            });
        }
    }

    renderInput = (label, type = "text", name, autoFocus = false, maxlength = 0) => {
        const { data } = this.state;
        const { errors } = this.state;
        const inputProps = {};
        if (maxlength > 0) {
            inputProps['maxLength'] = maxlength;
        }

        return (
            <TextField
                margin="normal"
                required={true}
                fullWidth
                id={name}
                label={label}
                name={name}
                value={data[name] || ''}
                autoComplete={name}
                autoFocus={autoFocus}
                type={type}
                onChange={this.handleChange}
                error={errors[name] && true}
                inputProps={inputProps}
            // helperText={errors[name]}
            />
        );
    };

    render() {
        const { dialogOpen, onClose, company } = this.props;
        return (
            <div>
                <Dialog maxWidth="xs" open={dialogOpen} aria-labelledby="form-dialog-title">
                    <form method="post" className="form-movie" onSubmit={this.handleSubmit}>

                        <DialogTitle id="form-dialog-title">{company.companyName}</DialogTitle>
                        <DialogContent>
                            {this.renderInput('Firmaadresse', 'text', 'address', true, 100)}
                            {this.renderInput('Postnummer', 'text', 'post', false, 8)}
                            {this.renderInput('By', 'text', 'town', false, 100)}
                            {this.renderInput('Free SMS', 'text', 'freeTextsPerMonth', false, 8)}
                            <div>
                                <strong>ReePay ID: </strong>{company.reepayId}
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button type="button" onClick={onClose} color="primary">Luk</Button>
                            <Button type="submit" color="primary">Gem</Button>
                        </DialogActions>
                    </form>

                </Dialog>
            </div>
        );
    }
}

export default EditCompanyForm;
